export default __webpack_public_path__ + "static/media/mumbai.7682d2a6.png";